<template>
  <div
    v-if="canShowContent"
    class="missing-translation-notification w-full mx-auto"
  >
    <RenderContent
      :content="internalCmsContent"
    />
  </div>
</template>

<script lang="ts">
import { COMPONENTS } from '~~/constants/cms';
import RenderContent from '~/cms/RenderContent.vue';

export default defineComponent({
  name: 'MissingTranslationNotification',
  components: {
    RenderContent,
  },
  setup () {

    const {
      loadComponent,
      canShowContent,
      internalCmsContent,
    } = useInternalCms(COMPONENTS.NOTIFICATION_BANNER.SLUG);

    useLazyAsyncData(`cms-${COMPONENTS.NOTIFICATION_BANNER.SLUG}`, async () => {

      await loadComponent();

      return '';
    
    });

    return {
      canShowContent,
      internalCmsContent,
    };
  
  },
});

</script>
